export default __webpack_public_path__ + "static/media/right.15aef9ba.svg";